import React from 'react';
import EvidenceTab from 'Common/Components/EvidenceTab';
import CustomFieldsTab from '../CustomFieldsTab';
import TechnicalTab from '../TechnicalTab';
import GeneralTab from '../GeneralTab';

const TABS_CONTEXT = [
  {
    id: 'general',
    intlId: 'manage.detail.tab.general',
    component: <GeneralTab />
  },
  {
    id: 'technicalDetails',
    intlId: 'manage.detail.tab.technicalDetails',
    component: <TechnicalTab />
  },
  {
    id: 'evidence',
    intlId: 'manage.detail.tab.evidence',
    component: <EvidenceTab />
  },
  {
    id: 'customFields',
    intlId: 'manage.detail.tab.customAttributes',
    component: <CustomFieldsTab />
  }
];

export default TABS_CONTEXT;
